import { render } from "./PatientCards.vue?vue&type=template&id=bc76ead8"
import script from "./PatientCards.vue?vue&type=script&lang=js"
export * from "./PatientCards.vue?vue&type=script&lang=js"

import "./PatientCards.vue?vue&type=style&index=0&id=bc76ead8&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__